// Sinestesia — Ajax Navigation SPA
// Navega todo via AJAX para que el SoundCloud nunca se interrumpa
(function() {
  var isNavigating = false;

  function getMain() {
    return document.getElementById('MainContent');
  }

  function isHomePage(url) {
    try {
      var a = new URL(url, window.location.origin);
      return a.pathname === '/' || a.pathname === '';
    } catch(e) { return false; }
  }

  function shouldIntercept(url) {
    try {
      var a = new URL(url, window.location.origin);
      if (a.hostname !== window.location.hostname) return false;
      // La Home siempre se carga completa (evita el bug de volver atras:
      // modales huerfanos de producto + scripts duplicados = imagenes gigantes)
      if (a.pathname === '/' || a.pathname === '') return false;
      // Solo excluir: carrito, cuenta, checkout, colecciones, paginas estaticas, blog
      // (/blogs incluido por bug de freeze de scroll en mobile tras navegacion AJAX)
      var skip = ['/cart', '/account', '/checkout', '/orders', '/challenge', '/collections', '/pages', '/blogs'];
      for (var i = 0; i < skip.length; i++) {
        if (a.pathname.indexOf(skip[i]) === 0) return false;
      }
      return true;
    } catch(e) { return false; }
  }

  function cleanDawnState() {
    document.documentElement.classList.remove('overflow-hidden');
    document.body.classList.remove('overflow-hidden');
    document.querySelectorAll('details[open]').forEach(function(d) {
      d.removeAttribute('open');
      d.classList.remove('menu-opening');
    });
    document.querySelectorAll('.menu-drawer, .cart-drawer').forEach(function(el) {
      el.removeAttribute('open');
      el.classList.remove('active', 'is-open');
    });
  }

  // Dawn's <modal-dialog> (usado por quick-add, zoom de imagen de producto, etc.)
  // se auto-mueve a document.body en su connectedCallback (fuera de MainContent).
  // Si no se limpia al navegar, queda "huerfano" en <body> sin su contenedor
  // .ratio/.card__media, y la imagen dentro se ve gigante (sin contencion de tamano).
  // Lo eliminamos antes de insertar el nuevo contenido.
  function removeOrphanedModals() {
    document.querySelectorAll('body > modal-dialog, body > quick-add-modal').forEach(function(el) {
      el.remove();
    });
  }

  function reinitScripts(container) {
    var scripts = container.querySelectorAll('script');
    scripts.forEach(function(oldScript) {
      var newScript = document.createElement('script');
      Array.from(oldScript.attributes).forEach(function(attr) {
        newScript.setAttribute(attr.name, attr.value);
      });
      newScript.textContent = oldScript.textContent;
      oldScript.parentNode.replaceChild(newScript, oldScript);
    });
  }

  function refreshSliders(container) {
    function doRefresh() {
      container.querySelectorAll('slider-component').forEach(function(slider) {
        if (typeof slider.initPages === 'function') {
          try { slider.initPages(); } catch (e) {}
        }
      });
      window.dispatchEvent(new Event('resize'));
    }

    var imgs = Array.from(container.querySelectorAll('img'));
    var pending = imgs.filter(function(img) { return !img.complete; });

    if (pending.length === 0) {
      requestAnimationFrame(function() { requestAnimationFrame(doRefresh); });
      return;
    }

    var remaining = pending.length;
    var done = false;
    function onOne() {
      remaining--;
      if (remaining <= 0 && !done) {
        done = true;
        requestAnimationFrame(function() { requestAnimationFrame(doRefresh); });
      }
    }
    pending.forEach(function(img) {
      img.addEventListener('load', onOne, { once: true });
      img.addEventListener('error', onOne, { once: true });
    });

    setTimeout(function() {
      if (!done) {
        done = true;
        doRefresh();
      }
    }, 1200);
  }

  function navigateTo(url, push, scrollY) {
    if (isNavigating) return;
    isNavigating = true;

    cleanDawnState();

    // cache: 'no-store' — este fetch alimenta una navegacion SPA y siempre
    // debe traer el HTML mas reciente del servidor (igual que una navegacion
    // normal del navegador). Sin esto, el navegador puede reusar una respuesta
    // cacheada vieja para la misma URL y mostrar contenido desactualizado
    // (por ejemplo, secciones agregadas/editadas despues de la ultima visita).
    fetch(url, { cache: 'no-store' })
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newMain = doc.getElementById('MainContent');
        var currentMain = getMain();

        if (!newMain || !currentMain) {
          window.location.href = url;
          return;
        }

        document.title = doc.title;

        // Limpiar modales/elementos que Dawn movio a <body> en la pagina anterior
        // (ej. el modal de zoom de imagen de producto) ANTES de insertar el nuevo contenido.
        removeOrphanedModals();

        // Mover los nodos reales (no por innerHTML/string) para que el
        // navegador no tenga que re-parsear <img srcset/sizes> desde texto.
        currentMain.replaceChildren.apply(currentMain, Array.from(newMain.childNodes));
        reinitScripts(currentMain);
        refreshSliders(currentMain);

        if (push !== false) {
          history.pushState({ url: url, scrollY: 0 }, doc.title, url);
        }

        window.scrollTo(0, scrollY || 0);

        document.dispatchEvent(new CustomEvent('shopify:section:load'));
        window.dispatchEvent(new CustomEvent('sn:page:loaded', { detail: { url: url } }));

        isNavigating = false;
      })
      .catch(function() {
        window.location.href = url;
        isNavigating = false;
      });
  }

  function bindLinks() {
    document.addEventListener('click', function(e) {
      var a = e.target.closest('a');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href) return;
      if (a.hasAttribute('target') && a.getAttribute('target') === '_blank') return;
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      if (!shouldIntercept(href)) return;

      history.replaceState(
        Object.assign({}, history.state || {}, { scrollY: window.scrollY }),
        document.title,
        window.location.href
      );

      e.preventDefault();
      navigateTo(href, true, 0);
    });
  }

  window.addEventListener('popstate', function(e) {
    var url = (e.state && e.state.url) ? e.state.url : window.location.href;
    // Colecciones, paginas estaticas, blog y Home: carga completa
    try {
      var a = new URL(url, window.location.origin);
      if (a.pathname.indexOf('/collections') === 0 || a.pathname.indexOf('/pages') === 0 || a.pathname.indexOf('/blogs') === 0 || a.pathname === '/' || a.pathname === '') {
        window.location.href = url;
        return;
      }
    } catch(e2) {}
    var scrollY = (e.state && e.state.scrollY) ? e.state.scrollY : 0;
    navigateTo(url, false, scrollY);
  });

  history.replaceState({ url: window.location.href, scrollY: 0 }, document.title, window.location.href);

  document.addEventListener('DOMContentLoaded', function() { bindLinks(); });
  if (document.readyState !== 'loading') { bindLinks(); }

})();
